<template>
<div class="blackBox">
    <div class="divButtonRigth" style="margin-bottom: 20px">
        <el-button type="success" size="small" @click="changeStatus('1')">启用</el-button>
        <el-button type="danger" size="small" @click="changeStatus('0')">禁用</el-button>
        <!--<el-button v-show="this.role.tenantId=='sys'? true:false" type="primary" size="small" @click="showAddDailog">新增</el-button>-->
        <el-button type="primary" size="small" @click="initRedisParameter">刷新缓存</el-button>
        <!--<el-button type="primary" size="small" @click="exportTableData">导出</el-button>-->
    </div>

    <bsp-table
        ref="sysCodeTable"
        :data.sync="list"
        :ciic-data-filter.sync="listQuery"
        @ciic-data-refresh="_getCodeListPage"
        @select-change="selectChange"
        @select-all="selectChange"
        show-header-overflow
        show-overflow
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
    >
        <vxe-table-column type="selection" width="60" fixed="left" align="center" ></vxe-table-column>
        <vxe-table-column title="序号" type="index" width="60" fixed="left" align="center"></vxe-table-column>
        <bsp-table-column
        title="代码集编号"
        field="setId"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.setId}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="代码集名称"
        field="setName"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.setName}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="英文名称"
        field="setEnName"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.setEnName}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="状态"
        field="setStatus"
        filter-type="select"
        :options-type="status"
        >
        <template slot-scope="scope">
            <!-- <el-switch
                class=""
                style="display: block"
                v-model="scope.row.setStatus"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="启用"
                active-value="1"
                inactive-value="0"
                @change="changeStatus(scope.row)"
            >
            </el-switch> -->
            <span>{{scope.row.setStatus | dictListFilter(status)}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="是否有层级"
        field="setLayer"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{layer[scope.row.setLayer]}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column title="操作">
        <template slot-scope="scope">
            <div class="ciic-table-operate">
                <el-button type="text" size="small" @click="goToCodeItemPage(scope.row)">
                    <i class="el-icon-search el-icon--right"></i>查看代码项
                </el-button>
                <!--<el-button type="text" size="small" @click="showUpdateDialog(scope.row)">-->
                    <!--<i class="el-icon-edit el-icon&#45;&#45;right"></i>编辑-->
                <!--</el-button>-->
            </div>
        </template>
        </bsp-table-column>
    </bsp-table>

    <sys-code-set-dialog
        ref="dialogForm"
        :status="status"
        :layer="layer"
        :dialog-status="dialogStatus"
        :dialog-form-visible.sync="dialogFormVisible"
        :list-form="listForm"
        @data-refresh="_getCodeListPage"
    >
    </sys-code-set-dialog>
</div>
</template>
<script>
import BspTable from "@/components/bsp/bsp-table/bsp-table";
import BspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
import SysCodeSetDialog from "@/views/sys/code/SysCodeSetDialog.vue";
import { getCodeSetListPage,changeCodeSetStatus,recacheCodeSet} from '@/api/sys/code';
import exportMethod from '@/util/export.js';
export default {
    name: 'SysCodeSet',
    components: {
        BspTable,
        BspTableColumn,
        SysCodeSetDialog
    },
    created() {
        this._getCodeListPage()
    },
    mounted() {
        // this._getCodeListPage();
    },

    data() {
        return {
            loading: false,
            // 弹框状态
            dialogStatus: 'add',
            dialogFormVisible: false,
            listForm:{},

            // 用于接收后台返回的分页数据
            list: [],
            //分页查询对象
            listQuery: {
                limit: 20,
                page: 1,
                total: 0
            },
            // 是否有层级
            layer: {
                0: '无层级',
                1: '有层级'
            },
            status:[
                {codeItemName:'禁用',codeItemId:'0'},
                {codeItemName:'启用',codeItemId:'1'}
            ],
            multipleSelection: []
        }
    },
    computed:{
    },
    methods: {
        // 跳转到代码项页面
        goToCodeItemPage(row){
            console.log('传递的代码集ID为：'+row.setId)
            this.$router.push({
                path: '/sys/codeItem',
                query:{
                    setId: row.setId
                }
            })
        },

        // 分页查询
        _getCodeListPage() {
            this.loading=true
            getCodeSetListPage(this.listQuery).then((res) => {
                this.listQuery.total=res.data.total
                this.list=res.data.records
                this.loading=false
            });
        },
        
        // 新增
        showAddDailog() {
          this.listForm = {
              setLayer: '0'
          };
          this.dialogFormVisible = true;
          this.dialogStatus = 'add';
        },
        showUpdateDialog(row) {
          this.listForm = JSON.parse(JSON.stringify(row));
          this.dialogFormVisible = true;
          this.dialogStatus = 'update';
        },
        // -----------------------------------------------
        //批量更改状态
        selectChange({checked, row}){
            if(checked&&row!=undefined){
                this.multipleSelection.push(row)
            }else if(checked){
                this.multipleSelection=JSON.parse(JSON.stringify(this.list))
            }
            if(!checked&&row!=undefined){
                this.multipleSelection.filter((item,index) => {
                    if(item===row){
                        this.multipleSelection.splice(index,1)
                    }
                })
            }else if(!checked){
              this.multipleSelection=[]
            }
        },
        changeStatus(status){
            let listSize=this.multipleSelection.length
            if(listSize==0){
                this.$message.error('请选择至少选中一行')
            }else{
                let param={
                    multipleSelection: this.multipleSelection,
                    status: status
                }
                changeCodeSetStatus(param).then(res =>{
                    if(res.data.code==0){
                      this.$message.success('操作完成')
                    }else{
                      this.$message.error('操作失败')
                    }
                })
              this._getCodeListPage()
            }
        },
        // ----------------------------------------------------------
        // 导出到excel
        exportTableData () {
          exportMethod(
            {
              columns: this.$refs['sysCodeTable'].tableColums,
              ...this.listQuery,
              type: "excel",
              beanName: "codeServiceImpl",
              methodName: "queryCodeSetList",
              headerRowNum: 2,
              fileName: "参数表格数据.xls",
              fileType: ".xls",
            },
            "/sys",true
          );
        },
        // 初始化到缓存
        initRedisParameter() {
          let listSize=this.multipleSelection.length
          if(listSize==0){
            this.$message.error('请选择至少选中一行')
          }else{
            let param={
              multipleSelection: this.multipleSelection
            }
            recacheCodeSet(param).then(res =>{
              if(res.data.code==0){
              this.$message.success('操作完成')
            }else{
              this.$message.error('操作失败')
            }
          })
          }
        },

    }
}
</script>
<style lang="scss">
.tenant-select {
  width: 100px;
  margin: 0px 10px;
}
</style>
